import React from 'react';

import PropTypes from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

const ProductPickerHeader = ({ className, style }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <div className={className} css={[{ padding: '0 15px' }, style]}>
      <div
        css={[
          { padding: '8px 0', color: theme.colors.charcoal700 },
          theme.typography.heading4,
        ]}
      >
        {T.translate('AVAILABLE_PROJECT')}
      </div>
      <Divider />
    </div>
  );
};

ProductPickerHeader.displayName = 'ProductPickerHeader';

ProductPickerHeader.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default ProductPickerHeader;
